import React from 'react';
import { Row, Col, Select } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

const SelectRow = styled(Row)``;

const StyledSelect = styled(Select)`
  & .ant-select-selection {
    border: 1px solid white;
  }
  &:hover {
    outline: 1px solid #d9d9d9;
    border-radius: 4px;
  }
`;
const Container = styled.div`
  marging: 10px;
`;

function VMRSselect(props) {
  const { title } = props;

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>{title}</Col>
      </Row>
      <SelectRow>
        <Col>
          <StyledSelect style={{ width: '100%' }} onChange={() => {}}>
            <Option value="jack">Jack</Option>
            <Option value="lucy">Lucy</Option>
            <Option value="disabled" disabled>
              Disabled
            </Option>
            <Option value="Yiminghe">yiminghe</Option>
          </StyledSelect>
        </Col>
      </SelectRow>
    </Container>
  );
}

export default VMRSselect;
